// Utility functions for date/time formatting

export const normalize = (dateStr: string) =>
  dateStr
    ? dateStr.replace(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/,
        "$1-$2-$3T$4:$5:$6Z"
      )
    : "";

export const formatDate = (dateStr: string) => {
  if (!dateStr) return { day: "", month: "" };
  const date = new Date(normalize(dateStr));
  return {
    day: date.getDate().toString().padStart(2, "0"),
    month: date.toLocaleString("en-AU", { month: "short" }),
  };
};

export const formatTimeRange = (startStr: string, endStr: string) => {
  if (!startStr || !endStr) return "";
  const start = new Date(normalize(startStr));
  const end = new Date(normalize(endStr));

  const formatOpts: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Australia/Sydney",
  };

  const startTime = start.toLocaleTimeString("en-AU", formatOpts);
  const endTime = end.toLocaleTimeString("en-AU", formatOpts);

  return `${startTime} - ${endTime} AEST`;
};
